module.exports = __webpack_public_path__ + "img/meetingroom.f2f228a7.jpg";